import { render } from "./Installation.vue?vue&type=template&id=5963c2ac&scoped=true"
import script from "./Installation.vue?vue&type=script&lang=js"
export * from "./Installation.vue?vue&type=script&lang=js"

import "./Installation.vue?vue&type=style&index=0&id=5963c2ac&scoped=true&lang=css"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5963c2ac"]])

export default __exports__